var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('v-textarea',_vm._g(_vm._b({attrs:{"id":_vm.id,"height":_vm.height,"auto-grow":"","rounded":"","solo":"","value":_vm.value,"rules":_vm.rules},on:{"input":function($event){return _vm.$emit('update', $event)}}},'v-textarea',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }